export default {"src":"/_next/static/media/faqIcon.d5440de5.svg","height":17,"width":18};